import styled from 'styled-components';
import { ViewVehicleProvider } from '../../context/ViewVehicleContext';
import { SectionLayout } from './components/SectionLayout';
import { ViewVehicleSectionsHeader } from './components/Header';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;

  @media (max-width: 1024px) {
    margin-top: 32px;
  }
`;

export const VehicleSections = () => {
  return (
    <ViewVehicleProvider>
      <Wrapper>
        <ViewVehicleSectionsHeader />
        <SectionLayout />
      </Wrapper>
    </ViewVehicleProvider>
  );
};
